{
    "hero": {
      "title": "Registre Sovereign Offset",
      "subtitle": "Plateforme simplifiée de gestion des crédits carbone soutenant les développeurs de projets, les auditeurs et les détenteurs de crédits avec un suivi complet du cycle de vie et une vérification.",
      "badges": {
        "article6": "Conforme à l'Article 6",
        "unfccc": "Aligné CCNUCC",
        "blockchain": "Intégré Blockchain"
      }
    },
    "access": {
      "title": "Choisissez Votre Chemin d'Accès",
      "subtitle": "Sélectionnez votre rôle pour accéder aux outils spécialisés d'enregistrement et de gestion",
      "developer": {
        "title": "Développeur de Projet",
        "description": "Soumettre des projets, gérer la documentation et suivre l'émission de crédits",
        "register": "S'inscrire",
        "login": "Connexion"
      },
      "auditor": {
        "title": "Auditeur (DOE)",
        "description": "Valider les projets et fournir des services de vérification",
        "register": "S'inscrire",
        "login": "Connexion"
      },
      "trader": {
        "title": "Détenteur de Crédits / Négociant",
        "description": "Acheter, négocier et retirer des crédits carbone",
        "register": "S'inscrire (Gratuit)",
        "login": "Connexion"
      },
      "government": {
        "title": "Gouvernement / DNA",
        "description": "Surveillance administrative et gestion réglementaire",
        "register": "S'inscrire",
        "login": "Connexion"
      },
      "legacy": {
        "title": "Enregistrement de Projet Hérité",
        "description": "Pour les projets existants en transition depuis d'autres normes (ICS, CDM, VCS)",
        "button": "Enregistrement de Chemin de Conformité"
      }
    },
    "announcements": {
      "title": "Dernières Annonces",
      "items": {
        "doe_guidelines": {
          "title": "Nouvelles Directives d'Accréditation DOE",
          "description": "Exigences mises à jour pour l'enregistrement d'Entité Opérationnelle Désignée et la validation de portée sectorielle.",
          "date": "15 décembre 2024"
        },
        "article6_update": {
          "title": "Mise à Jour de l'Implémentation Article 6",
          "description": "Mécanismes d'approche coopérative améliorés maintenant disponibles pour les transferts internationaux.",
          "date": "10 décembre 2024"
        },
        "maintenance": {
          "title": "Avis de Maintenance Système",
          "description": "Maintenance programmée le 20 décembre 2024 de 2h00 à 4h00 UTC.",
          "date": "8 décembre 2024"
        }
      }
    },
    "downloads": {
      "title": "Téléchargements de Documents",
      "items": {
        "pin_template": "Modèle PIN",
        "pdd_template": "Modèle PDD",
        "npramp_guide": "Guide NPRAMP",
        "user_manual": "Manuel Utilisateur"
      }
    },
    "explorer": {
      "title": "Explorateur de Registre",
      "subtitle": "Parcourir les projets actifs et les transactions de crédits",
      "filters": {
        "all_categories": "Toutes Catégories",
        "all_status": "Tous Statuts",
        "search_button": "Rechercher Registre"
      },
      "stats": {
        "active_projects": "Projets Actifs",
        "credits_issued": "Crédits Émis",
        "credits_retired": "Crédits Retirés"
      }
    }
}